import React, { Component } from "react";

import WinnersTabs from "./WinnersTabs";

export default class Winners extends Component {
  

  render() {
    const { language, winners } = this.props;
    return (
      <div className="winners" id="winners">
        <h3> {language === "et" ? "Võitjad" : "Победители "}</h3>
        <WinnersTabs winners={winners} language={this.props.language} />
      
      </div>
    );
  }
}
